import SettingsHeader from './SettingsHeader';

export default SettingsHeader;
